import { render } from "./AdjustSpda.vue?vue&type=template&id=17827920"
import script from "./AdjustSpda.vue?vue&type=script&lang=js"
export * from "./AdjustSpda.vue?vue&type=script&lang=js"
script.render = render

export default script